/** Admin Places API (CRUD + workflow). */
import apiClient from '@/services/api/client';

export const listPlaces = async () => (await apiClient.get('/v1/places')).data;
export const createPlace = async (p) => (await apiClient.post('/v1/places', p)).data;
export const updatePlace = async (id, p) => (await apiClient.put(`/v1/places/${id}`, p)).data;
export const publishPlace = async (id) => (await apiClient.post(`/v1/places/${id}/publish`)).data;
export const archivePlace = async (id) => (await apiClient.post(`/v1/places/${id}/archive`)).data;
export const deletePlace = async (id) => apiClient.delete(`/v1/places/${id}`);
